import axiosInstance from '@/setup/axios/axiosInstance'
import { Company, CompanyFormData } from '../models/CompanyModel'
import { AxiosResponse } from 'axios'

interface CompanyListResponse {
  results?: Company[]
}

let inFlightGetCompanies: Promise<AxiosResponse<Company[] | CompanyListResponse>> | null = null

// Get all companies
export function getCompanies() {
  if (inFlightGetCompanies) {
    return inFlightGetCompanies
  }

  inFlightGetCompanies = axiosInstance.get<Company[] | CompanyListResponse>('/companies/')
    .finally(() => {
      inFlightGetCompanies = null
    })

  return inFlightGetCompanies
}

// Get single company by ID
export function getCompany(id: string) {
  return axiosInstance.get<Company>(`/companies/${id}/`)
}

// Create new company
export function createCompany(companyData: CompanyFormData) {
  console.log('Creating company with data:', companyData);
  
  // Create FormData for file upload
  const formData = new FormData();
  
  // Add all text fields
  Object.keys(companyData).forEach(key => {
    const value = companyData[key as keyof CompanyFormData];
    if (value !== null && value !== undefined) {
      if (key === 'logo' && value instanceof File) {
        // Handle file upload
        console.log('Adding logo file to FormData:', value);
        formData.append('logo', value);
      } else if (key === 'address') {
        // Handle address object - if it has an id, use it as address_id
        if (value && typeof value === 'object' && 'id' in value) {
          formData.append('address_id', String((value as any).id));
        } else if (value && typeof value === 'object') {
          // If it's an address object without id, we need to create the address first
          // Send address data as separate fields
          const addressData = value as any;
          if (addressData.address_line) formData.append('address_line', addressData.address_line);
          if (addressData.province) formData.append('province', addressData.province);
          if (addressData.ward) formData.append('ward', addressData.ward);
          if (addressData.free_address) formData.append('free_address', addressData.free_address);
        } else {
          formData.append('address_id', String(value));
        }
      } else if (key !== 'logo') {
        // Handle other fields - include empty strings
        formData.append(key, String(value));
      }
    }
  });
  
  console.log('FormData entries:');
  formData.forEach((value, key) => {
    console.log(`${key}:`, value);
  });
  
  return axiosInstance.post<Company>('/companies/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

// Update company
export function updateCompany(id: string, companyData: CompanyFormData) {
  // Create FormData for file upload
  const formData = new FormData();
  
  // Add all text fields
  Object.keys(companyData).forEach(key => {
    const value = companyData[key as keyof CompanyFormData];
    if (value !== null && value !== undefined) {
      if (key === 'logo' && value instanceof File) {
        // Handle file upload
        formData.append('logo', value);
      } else if (key === 'address') {
        // Handle address object - if it has an id, use it as address_id
        if (value && typeof value === 'object' && 'id' in value) {
          formData.append('address_id', String((value as any).id));
        } else if (value && typeof value === 'object') {
          // If it's an address object without id, we need to create the address first
          // Send address data as separate fields
          const addressData = value as any;
          if (addressData.address_line) formData.append('address_line', addressData.address_line);
          if (addressData.province) formData.append('province', addressData.province);
          if (addressData.ward) formData.append('ward', addressData.ward);
          if (addressData.free_address) formData.append('free_address', addressData.free_address);
        } else {
          formData.append('address_id', String(value));
        }
      } else if (key !== 'logo') {
        // Handle other fields - include empty strings
        formData.append(key, String(value));
      }
    }
  });
  
  return axiosInstance.put<Company>(`/companies/${id}/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

// Delete company
export function deleteCompany(id: string) {
  return axiosInstance.delete(`/companies/${id}/`)
} 